import axios from 'axios'
import { getOneMonthAgo } from '../../../utils'

export async function getDashboardDevices() {
    return axios
        .get(`${process.env.API_URL}/devices/dashboard`)
        .then(response => response.data)
}

export async function getDashboardReports(params) {
    return axios
        .get(`${process.env.API_URL}/reports`, {
            params: {
                from: getOneMonthAgo(),
                statuses: ['critical'],
                take: 200,
                ...params
            }
        })
        .then(response => response.data)
}

export async function getLocations() {
    return axios
        .get(`${process.env.API_URL}/locations`, {
            params: {
                w_fp_flag: 1
            }
        })
        .then(response => response.data)
}
export async function getDashboardPreferrence() {
    return axios
        .get(`${process.env.API_URL}/users/preferences/dashboard-view`)
        .then(response => response.data)
}
export async function updateDashboardPreference(dashboardViewOption) {
    return axios
        .patch(`${process.env.API_URL}/users/preferences/dashboard-view`, {
            preferred_dashboard_view: dashboardViewOption
        })
        .then(response => response.data)
}
export async function updateAddress(locationId, newAddress) {
    return axios
        .patch(`${process.env.API_URL}/locations/${locationId}/address`, {
            address: newAddress
        })
        .then(response => response.data)
}
